// ─── Sélecteurs de base ───────────────────────────────────────────────────────
const selectCnssRoot = (state) => state.cnss;

// ── Cartes ───────────────────────────────────────────────────────────────────
export const selectAllCards       = (state) => selectCnssRoot(state).cards;
export const selectCurrentCard    = (state) => selectCnssRoot(state).currentCard;
export const selectUnverifiedCards = (state) => selectCnssRoot(state).unverifiedCards;
export const selectExpiringCards  = (state) => selectCnssRoot(state).expiringCards;
export const selectExpiredCards   = (state) => selectCnssRoot(state).expiredCards;
export const selectSearchResults  = (state) => selectCnssRoot(state).searchResults;
export const selectVerificationResult = (state) => selectCnssRoot(state).verificationResult;

// ── Dépendants ────────────────────────────────────────────────────────────────
export const selectDependents       = (state) => selectCnssRoot(state).dependents;
export const selectCurrentDependent = (state) => selectCnssRoot(state).currentDependent;
export const selectAllDependents    = (state) => selectCnssRoot(state).allDependents;

// ── Actes médicaux (Bulletin de Soins) ───────────────────────────────────────
export const selectMedicalActs = (state) => selectCnssRoot(state).medicalActs;

/** Actes filtrés par type */
export const selectActsByType = (type) => (state) => {
  const acts = selectMedicalActs(state);
  if (!type) return acts;
  return acts.filter((a) => a.type === type);
};

/** Consultations & Visites */
export const selectConsultations = (state) =>
  selectActsByType("CONSULTATION_VISITE")(state);

/** Actes médicaux & paramédicaux */
export const selectActesMedicaux = (state) =>
  selectActsByType("ACTE_MEDICAL")(state);

/** Accouchements & Hospitalisations */
export const selectAccouchements = (state) =>
  selectActsByType("ACCOUCHEMENT_HOSPITALISATION")(state);

/** Total des honoraires */
export const selectTotalHonoraires = (state) =>
  selectMedicalActs(state).reduce(
    (sum, act) => sum + Number(act.honoraires ?? 0),
    0
  );

  export const selectDoctorPatientCards = (state) =>
  selectCnssRoot(state).doctorPatientCards;

export const selectCurrentDoctorPatientCard = (state) => {
  const cards = selectDoctorPatientCards(state);
  return Array.isArray(cards) && cards.length > 0 ? cards[0] : null;
};

export const selectIsLoadingDoctorPatientCards = (state) =>
  selectCnssLoading(state).doctorPatientCards;

// ── Statistiques ──────────────────────────────────────────────────────────────
export const selectStatistics  = (state) => selectCnssRoot(state).statistics;
export const selectGlobalStats = (state) => selectCnssRoot(state).globalStats;

// ── UI ────────────────────────────────────────────────────────────────────────
export const selectCnssLoading = (state) => selectCnssRoot(state).loading;
export const selectCnssError   = (state) => selectCnssRoot(state).error;
export const selectCnssSuccess = (state) => selectCnssRoot(state).success;

// Raccourcis par clé de loading
export const selectIsLoadingCards      = (state) => selectCnssLoading(state).cards;
export const selectIsLoadingCard       = (state) => selectCnssLoading(state).card;
export const selectIsCreating          = (state) => selectCnssLoading(state).create;
export const selectIsUpdating          = (state) => selectCnssLoading(state).update;
export const selectIsDeleting          = (state) => selectCnssLoading(state).delete;
export const selectIsLoadingMedicalActs = (state) => selectCnssLoading(state).medicalActs;
export const selectIsCreatingAct       = (state) => selectCnssLoading(state).createAct;
export const selectIsDeletingAct       = (state) => selectCnssLoading(state).deleteAct;
export const selectIsLoadingDependents = (state) => selectCnssLoading(state).dependents;
export const selectIsAddingDependent   = (state) => selectCnssLoading(state).addDependent;
export const selectIsSearching         = (state) => selectCnssLoading(state).search;
export const selectIsVerifying         = (state) => selectCnssLoading(state).verify;